function initFaqAccordions(root) {
  const scope = root || document;
  const faqSections = scope.querySelectorAll(".block__faqs-list");

  faqSections.forEach((section) => {
    const accItems = section.querySelectorAll(".block__faqs-acc");

    accItems.forEach((item) => {
      if (item.dataset.faqInitialized === "true") return;

      const answer = item.querySelector(".block__faqs-acc-content");
      if (!answer) return;

      item.dataset.faqInitialized = "true";
      answer.style.maxHeight = item.classList.contains("active") ? answer.scrollHeight + "px" : "0px";
      answer.style.overflow = "hidden";
      answer.style.transition = "max-height 0.4s ease";

      item.addEventListener("click", function () {
        accItems.forEach((otherItem) => {
          const otherAnswer = otherItem.querySelector(".block__faqs-acc-content");
          if (otherItem !== item && otherAnswer) {
            otherAnswer.style.maxHeight = "0px";
            otherItem.classList.remove("active");
          }
        });

        const isOpen = item.classList.contains("active");

        if (!isOpen) {
          answer.style.maxHeight = answer.scrollHeight + "px";
          item.classList.add("active");
        } else {
          answer.style.maxHeight = "0px";
          item.classList.remove("active");
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  initFaqAccordions(document);
});

document.addEventListener("shopify:section:load", function (event) {
  initFaqAccordions(event.target);
});
